import React from 'react'
import styles from './SearchBarOptions.module.sass'
import Tab from 'src/lib/ui/Tabs/Tab'
import Tabs from 'src/lib/ui/Tabs/Tabs'

export const SortTabs = ({ options, value, onClick }) =>
  Object.keys(options).map(key => (
    <Tab
      className={styles.tab}
      key={key}
      selected={key === value}
      onClick={onClick(key)}
      data-piwik-class="sort-button"
      showsActiveBar
    >
      {options[key]}
    </Tab>
  ))

const SearchByOptions = props => (
  <Tabs className={styles.container}>
    <SortTabs {...props} />
  </Tabs>
)

export default SearchByOptions
